import { CurrencyPipe, PercentPipe } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { BaseModal } from '../../shared'
import { Employee, WageChange } from './org-chart.component'

@Component({
    templateUrl: './wage-modal.component.html',
    styleUrls: ['./wage-modal.component.css'],
    standalone: true,
    imports: [FormsModule, PercentPipe, CurrencyPipe],
})
export class WageModalComponent extends BaseModal {
    employee!: Employee

    get wageChanges(): WageChange[] {
        return this.employee?.wageChanges ?? []
    }

    get wageHistory(): WageChange[] {
        return this.employee?.wageHistory ?? []
    }
}
